"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDomainObject = void 0;
function createDomainObject(domainObjectType, domainObjectId) {
    var _a;
    if (!domainObjectType || !domainObjectId)
        return;
    return _a = {},
        _a[domainObjectType] = [domainObjectId],
        _a;
}
exports.createDomainObject = createDomainObject;
